import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0726ee7c")

_pushScopeId("data-v-0726ee7c")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex-grow flex flex-col justify-between h-screen" }
const _hoisted_3 = { class: "flex-grow flex flex-col items-center bg-primary-100 overflow-y-scroll pt-12" }
const _hoisted_4 = { class: "panel-container rounded-md bg-white pb-2" }
const _hoisted_5 = { class: "table-header-color w-full px-4 py-3 flex items-center justify-end lg:justify-between" }
const _hoisted_6 = { class: "hidden lg:flex" }
const _hoisted_7 = { class: "flex items-center space-x-2" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "まとめて編集", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "スタッフ追加", -1)
const _hoisted_10 = {
  key: 1,
  class: "flex"
}
const _hoisted_11 = { class: "flex-grow flex flex-col justify-between h-screen" }
const _hoisted_12 = { class: "flex-grow flex items-start justify-center bg-primary-100 overflow-y-auto px-4 pt-12" }
const _hoisted_13 = { class: "w-full max-w-2xl rounded-md bg-white px-6 py-10 text-center shadow-sm" }
const _hoisted_14 = /*#__PURE__*/_createVNode("h1", { class: "text-xl font-bold text-gray-800" }, " スタッフ管理画面が移動しました ", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "mt-4 text-gray-600 leading-7" }, [
  /*#__PURE__*/_createTextVNode(" スタッフの確認・作成・編集は、"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" スクールAIのスタッフ管理画面から行えます。 ")
], -1)
const _hoisted_16 = { class: "mt-8 flex justify-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MNavBar = _resolveComponent("MNavBar")
  const _component_MHeaderPanel = _resolveComponent("MHeaderPanel")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_table = _resolveComponent("m-table")
  const _component_ms_add_modal = _resolveComponent("ms-add-modal")
  const _component_ms_edit_modal = _resolveComponent("ms-edit-modal")
  const _component_ms_csv_update_modal = _resolveComponent("ms-csv-update-modal")

  return (_ctx.isStudyRoomOnly)
    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_MNavBar),
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_MHeaderPanel, {
              title: "スタッフ管理",
              breadcrumbs: []
            }),
            _createVNode("main", _hoisted_3, [
              _createVNode("section", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchKeyword = $event)),
                      type: "search",
                      name: "searchStaff",
                      placeholder: "名前で検索...",
                      class: "w-60 bg-white rounded border border-white focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300"
                    }, null, 512), [
                      [_vModelText, _ctx.searchKeyword]
                    ])
                  ]),
                  _createVNode("div", _hoisted_7, [
                    (_ctx.canBulkUpdateTutors)
                      ? (_openBlock(), _createBlock(_component_m_button, {
                          key: 0,
                          color: "primary-500",
                          "hover-color": "primary-600",
                          onClick: _ctx.handleEditStaffViaCsv
                        }, {
                          default: _withId(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.isAdminOfSchool || _ctx.isSupervisorOfSchool)
                      ? (_openBlock(), _createBlock(_component_m_button, {
                          key: 1,
                          color: "primary-500",
                          "hover-color": "primary-600",
                          onClick: _ctx.showAddModal
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_m_icon, {
                              type: "plus",
                              width: "4",
                              class: "mr-2"
                            }),
                            _hoisted_9
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(_component_m_table, {
                  datas: _ctx.filteredDatas,
                  definitions: _ctx.definitions,
                  "default-sort-key": "studentNum",
                  editable: "",
                  onSelect: _ctx.changeSelectedId
                }, null, 8, ["datas", "definitions", "onSelect"])
              ]),
              _createVNode("input", {
                ref: "fileInput",
                type: "file",
                accept: ".csv",
                hidden: "",
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCsvFileInputForUpdate && _ctx.onCsvFileInputForUpdate(...args)))
              }, null, 544)
            ])
          ])
        ]),
        (_ctx.isDisplayedAddTutorModal && _ctx.tutor)
          ? (_openBlock(), _createBlock(_component_ms_add_modal, {
              key: 0,
              classrooms: _ctx.accessibleClassRooms,
              tutor: _ctx.tutor,
              onClose: _ctx.closeAddModal
            }, null, 8, ["classrooms", "tutor", "onClose"]))
          : _createCommentVNode("", true),
        (_ctx.isDisplayedEditTutorModal && _ctx.tutor && _ctx.selectedTutor)
          ? (_openBlock(), _createBlock(_component_ms_edit_modal, {
              key: 1,
              classrooms: _ctx.accessibleClassRooms,
              tutor: _ctx.tutor,
              "edit-tutor": _ctx.selectedTutor,
              "edit-tutor-email": _ctx.selectedTutorEmail,
              onClose: _ctx.closeEditModal
            }, null, 8, ["classrooms", "tutor", "edit-tutor", "edit-tutor-email", "onClose"]))
          : _createCommentVNode("", true),
        (_ctx.isDisplayedCsvUpdateModal)
          ? (_openBlock(), _createBlock(_component_ms_csv_update_modal, {
              key: 2,
              "is-owner": _ctx.isOwnerOfSchool,
              "is-school": _ctx.isSchool,
              onClose: _ctx.closeCsvUpdateModal,
              onClickFileInputRef: _ctx.handleClickFileInputRef,
              onExportAllStaffs: _ctx.handleExportAllStaffs
            }, null, 8, ["is-owner", "is-school", "onClose", "onClickFileInputRef", "onExportAllStaffs"]))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createBlock("div", _hoisted_10, [
        _createVNode(_component_MNavBar),
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_MHeaderPanel, {
            title: "スタッフ管理",
            breadcrumbs: []
          }),
          _createVNode("main", _hoisted_12, [
            _createVNode("section", _hoisted_13, [
              _hoisted_14,
              _hoisted_15,
              _createVNode("div", _hoisted_16, [
                _createVNode("a", {
                  href: _ctx.newStaffManagementUrl,
                  class: "inline-flex items-center rounded-md font-medium text-sm transition-all duration-300 px-4 py-2 text-white bg-primary-500 hover:bg-primary-600 cursor-pointer"
                }, " 新しいスタッフ管理画面を開く ", 8, ["href"])
              ])
            ])
          ])
        ])
      ]))
})